export class User {
  id: string;
  name: string;
  role_name: string;
  email: string;
  card_nr?: string
  photo?: string;
  password?: string;
  restaurant_ids?: string[];
  location_ids?: string[];

  constructor(id?: string, fullName?: string, role_name?: string, email?: string, card_nr?: string, photo?: string, restaurant_ids?: string[], location_ids?: string[]) {
    this.id = id || null;
    this.name = fullName || null;
    this.role_name = role_name || null;
    this.email = email || null;
    this.card_nr = card_nr || null
    if(photo){
      this.photo = photo;
    }
    this.restaurant_ids = restaurant_ids;
    this.location_ids = location_ids;
  }
}
